<div class="section border-bottom p-3">
    <div class="title d-flex">
        <div class="flex-1">{{ handler?.title }}</div>
        <div *ngIf="cellset && currentValue">{{ currentValue }} <span *ngIf="diffValue !== '0'"
                [class]="'text-' + (diffIcon.includes('up') ? 'success' : 'danger')">
                <kui-icon [name]="diffIcon"></kui-icon> {{ diffValue }}
            </span></div>
    </div>
    <div class="chart flex-1 d-flex mt-3 p-1">

        <div class="loader d-flex flex-stretch justify-content-center align-items-center"
            *ngIf="!cellset && !errorMessage">
            <kui-loader>
            </kui-loader>
        </div>

        <kui-alert-panel [size]="3" [message]="errorMessage"></kui-alert-panel>

        <key-analytics-chart *ngIf="cellset && !errorMessage"
            [type]="chartType"
            [cellset]="cellset"
            [settings]="settings"
            [size]="'large'"
            (onLoad)="onChartLoaded($event)"></key-analytics-chart>

    </div>
</div>